class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    if (this.hasAttribute('data-td-hover')) this.initHover();
  }

  // Header setting menu_parent_hover: on devices with a mouse, hover opens the
  // dropdown and the title link navigates. Touch keeps tap-to-open: the first tap
  // on a closed item opens it instead of following the title link.
  initHover() {
    const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
    const parentLink = this.querySelector('summary .td-menu-parent-link');

    this.addEventListener('mouseenter', () => {
      if (!canHover.matches) return;
      clearTimeout(this.hoverCloseTimer);
      this.open();
    });
    this.addEventListener('mouseleave', () => {
      if (!canHover.matches) return;
      // Short grace period so the pointer can cross the gap down to the panel.
      this.hoverCloseTimer = setTimeout(() => this.close(), 150);
    });

    if (parentLink) {
      parentLink.addEventListener('click', (event) => {
        if (canHover.matches || this.mainDetailsToggle.open) return;
        event.preventDefault();
        this.open();
      });
    }
  }

  open() {
    if (this.mainDetailsToggle.open) return;
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
